export class Seguro {
  private id: number;
  private valor: number;

  constructor(id?: number, valor?: number) {
    this.id = id;
    this.valor = valor;
  }
}
